import React from 'react';
import InputField from '../../Forms/Input/InputField';
import TextAreaField from '../../Forms/Input/TextAreaField';
import { ProductFormValues } from '../../../types/product/ProductFormValues';
import { useProduct } from '../../../hooks/useProduct';

interface Props {
  form: ProductFormValues;
  onChange: (field: keyof ProductFormValues, value: any) => void;
}

const ServiceFields: React.FC<Props> = ({ form, onChange }) => {
  const { formErrors } = useProduct();

  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
      <h3 className="text-gray-800 col-span-1 text-lg font-semibold dark:text-white md:col-span-2">
        Información del Servicio
      </h3>

      {/* Nombre */}
      <InputField
        label="Nombre:"
        name="name"
        iconKey="service"
        type="text"
        value={form.name}
        onChange={(e) => onChange('name', e.target.value)}
        required
        error={formErrors.name}
      />

      {/* Código (solo lectura) */}
      {form.id != null && (
        <InputField
          label="Código:"
          name="code"
          iconKey="barcode"
          type="text"
          value={form.code || ''}
          onChange={() => {}}
          error={formErrors.code}
          disabled
        />
      )}

      {/* Precio */}
      <InputField
        label="Precio Venta:"
        name="price"
        type="number"
        iconKey="dollar"
        step="0.01"
        min={0}
        value={form.price}
        onChange={(e) => onChange('price', parseFloat(e.target.value))}
        placeholder="Ejemplo: 25.00"
        required
        error={formErrors.price}
      />

      {/* ✅ Precio mínimo (OBLIGATORIO) */}
      <InputField
        label="Precio Mínimo:"
        name="minimumSalePrice"
        type="number"
        iconKey="priceDown"
        step="0.01"
        min={0}
        value={form.minimumSalePrice}
        onChange={(e) =>
          onChange('minimumSalePrice', parseFloat(e.target.value))
        }
        placeholder="Ejemplo: 20.00"
        required
        error={formErrors.minimumSalePrice}
      />

      {/* Descripción */}
      <div className="md:col-span-2">
        <TextAreaField
          label="Descripción:"
          name="description"
          value={form.description}
          onChange={(e) => onChange('description', e.target.value)}
          rows={5}
          placeholder="Detalle el servicio ofrecido"
          iconKey="edit"
          error={formErrors.description}
        />
      </div>
    </div>
  );
};

export default ServiceFields;
